import { createStore } from "owa-satcheljs";
import type { AppPaneUnderlayViewState } from "./schema/AppPaneUnderlayViewState";

const defaultAppPaneUnderlayStore: AppPaneUnderlayViewState = {
    isShown: new Map(),
    shrinkable: new Map(),
    isPlaceholder: new Map(),
};

export const getStore: () => AppPaneUnderlayViewState = createStore<AppPaneUnderlayViewState>("AppPaneUnderlayViewState", defaultAppPaneUnderlayStore);

export default getStore;
